import DateFormat from "../common/dateFormat/DateFormat";

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	filtro: {
		data_inicial: DateFormat.getDataInicioMesAtual(),
		data_final: DateFormat.getDataAtual(),
		ordenacao_ordem: 'crescente',
		ordenacao_coluna: 'data_receita'
	}
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'RECEITA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'RECEITA_SET_FILTRO':
			return {
				...state,
				filtro: action.payload
			};

		case 'RECEITA_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

		case 'RECEITA_LISTADO':
            return {
                ...state, 
                lista: action.payload.data
            };

        default:
            return state;
    }
}
